var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnerPuppyAffectV1(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 9.58334L9.58325 11.6667L8.33325 10.4167",
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24992 5V2.5",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 5V2.5",
    stroke: "#7A7670",
    style: (_ref4 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 6.25V13.1311C17.5 13.7942 17.2366 14.4301 16.7678 14.8989L14.8989 16.7678C14.4301 17.2366 13.7942 17.5 13.1311 17.5H5C3.61929 17.5 2.5 16.3807 2.5 15V6.25C2.5 4.86929 3.61929 3.75 5 3.75H15C16.3807 3.75 17.5 4.86929 17.5 6.25Z",
    stroke: "#7A7670",
    style: (_ref5 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 12.9167H14.5834C13.6629 12.9167 12.9167 13.6628 12.9167 14.5833V17.5",
    stroke: "#7A7670",
    style: (_ref6 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref6, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref6, "strokeOpacity", 1), _ref6),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerPuppyAffectV1);
export default __webpack_public_path__ + "static/media/ownerPuppyAffectV1.c6c4ce32e335da5d2a07e3f283331a47.svg";
export { ForwardRef as ReactComponent };